import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-arrow-next.png'

const ArrowNextIcon = (props: any) => {
  return <BaseIcon img={img} onClick={props.onClick} />
}

export default ArrowNextIcon
